import Pagination from '../Pagination/Pagination'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { trackCtaClick } from 'services/analyticsService'
import './SolutionsDigitalSupplyChain.css'

const SolutionsDigitalSupplyChain = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const casesDigitalSupplyChain = [
    {
      id: 1,
      title: t('solutionsDigitalSupplyChain_page.cases.items.demandForecast.title'),
      description: t(
        'solutionsDigitalSupplyChain_page.cases.items.demandForecast.description',
      ),
      icon: '',
      url: 'previsao-de-demanda',
    },
    {
      id: 2,
      title: t('solutionsDigitalSupplyChain_page.cases.items.replenishmentStock.title'),
      description: t(
        'solutionsDigitalSupplyChain_page.cases.items.replenishmentStock.description',
      ),
      icon: '',
      url: 'abastecimento-e-politica-de-estoque',
    },
    {
      id: 3,
      title: t(
        'solutionsDigitalSupplyChain_page.cases.items.availabilityConfirmation.title',
      ),
      description: t(
        'solutionsDigitalSupplyChain_page.cases.items.availabilityConfirmation.description',
      ),
      icon: '',
      url: 'confirmacao-de-disponibilidade',
    },
    {
      id: 4,
      title: t('solutionsDigitalSupplyChain_page.cases.items.apsLogisticsMesh.title'),
      description: t(
        'solutionsDigitalSupplyChain_page.cases.items.apsLogisticsMesh.description',
      ),
      icon: '',
      url: 'malha-logistica-no-sistema',
    },
    {
      id: 5,
      title: t('solutionsDigitalSupplyChain_page.cases.items.planningOptimization.title'),
      description: t(
        'solutionsDigitalSupplyChain_page.cases.items.planningOptimization.description',
      ),
      icon: '',
      url: 'planejamento-e-otimizacao',
    },
    {
      id: 6,
      title: t('solutionsDigitalSupplyChain_page.cases.items.industryPlanning.title'),
      description: t(
        'solutionsDigitalSupplyChain_page.cases.items.industryPlanning.description',
      ),
      icon: '',
      url: 'planejamento-na-industria',
    },
    {
      id: 7,
      title: t('solutionsDigitalSupplyChain_page.cases.items.projectDreams.title'),
      description: t(
        'solutionsDigitalSupplyChain_page.cases.items.projectDreams.description',
      ),
      icon: '',
      url: 'projeto-dreams',
    },
    {
      id: 8,
      title: t('solutionsDigitalSupplyChain_page.cases.items.integraSapIbpSupply.title'),
      description: t(
        'solutionsDigitalSupplyChain_page.cases.items.integraSapIbpSupply.description',
      ),
      icon: '',
      url: 'integra-SAP-IBP-supply-chain',
    },
  ]

  const handleRelatedCaseCtaClick = (caseItem) => {
    const ctaText = t('solutionsDigitalSupplyChain_page.cases.cta')
    trackCtaClick({
      cta_name: 'solutions_related_case_click',
      cta_location: 'solutions_digital_supply_chain',
      page_name: 'solutions_digital_supply_chain',
      case_title: caseItem.title,
      destination_path: `/${caseItem.url}`,
      cta_text: ctaText,
    })
    navigate(`/${caseItem.url}`)
  }

  return (
    <section className="main-container supply-chain">
      <header className="main-container-top">
        <div className="text">
          <h1>{t('solutionsDigitalSupplyChain_page.title')}</h1>
          <p>{t('solutionsDigitalSupplyChain_page.subtitle')}</p>
        </div>
        <div className="image-container">
          <img
            src="/assets/SolutionsPage/digital supply chain.png"
            alt={t('solutionsDigitalSupplyChain_page.imageAlt')}
          />
        </div>
      </header>

      <div className="main-content">
        <div className="main-content-primary">
          <h2>{t('solutionsDigitalSupplyChain_page.main.title')}</h2>
          <p>{t('solutionsDigitalSupplyChain_page.main.p1')}</p>
          <p>{t('solutionsDigitalSupplyChain_page.main.p2')}</p>
          <div className="image-content">
            <img
              className="full-width-image supply-chain"
              src="/assets/SolutionsPage/circulo.png"
              alt={t('solutionsDigitalSupplyChain_page.main.imagesAlt')}
            />
            <img
              className="full-width-image supply-chain-square"
              src="/assets/SolutionsPage/quadrado.png"
              alt={t('solutionsDigitalSupplyChain_page.main.imagesAlt')}
            />
          </div>
          <p>{t('solutionsDigitalSupplyChain_page.main.p3')}</p>
          <p className="PaddingSupplyChain">
            {t('solutionsDigitalSupplyChain_page.main.p4')}
          </p>
        </div>
      </div>

      <div className="main-content-extra">
        <h2>{t('solutionsDigitalSupplyChain_page.performance.title')}</h2>
        <div className="supply-chain-cards-container">
          <div className="supply-chain-card">
            <h3>
              {t('solutionsDigitalSupplyChain_page.performance.cards.projects.title')}
            </h3>
            <span>
              {t('solutionsDigitalSupplyChain_page.performance.cards.projects.subtitle')}
            </span>
            <ul>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.projects.items.item1',
                )}
              </li>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.projects.items.item2',
                )}
              </li>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.projects.items.item3',
                )}
              </li>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.projects.items.item4',
                )}
              </li>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.projects.items.item5',
                )}
              </li>
            </ul>
          </div>
          <div className="supply-chain-card">
            <h3>
              {t('solutionsDigitalSupplyChain_page.performance.cards.diagnostics.title')}
            </h3>
            <span>
              {t(
                'solutionsDigitalSupplyChain_page.performance.cards.diagnostics.subtitle',
              )}
            </span>
            <ul>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.diagnostics.items.item1',
                )}
              </li>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.diagnostics.items.item2',
                )}
              </li>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.diagnostics.items.item3',
                )}
              </li>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.diagnostics.items.item4',
                )}
              </li>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.diagnostics.items.item5',
                )}
              </li>
            </ul>
          </div>
          <div className="supply-chain-card">
            <h3>
              {t('solutionsDigitalSupplyChain_page.performance.cards.allocation.title')}
            </h3>
            <span>
              {t(
                'solutionsDigitalSupplyChain_page.performance.cards.allocation.subtitle',
              )}
            </span>
            <ul>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.allocation.items.item1',
                )}
              </li>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.allocation.items.item2',
                )}
              </li>
            </ul>
          </div>
          <div className="supply-chain-card">
            <h3>
              {t('solutionsDigitalSupplyChain_page.performance.cards.support.title')}
            </h3>
            <span>
              {t('solutionsDigitalSupplyChain_page.performance.cards.support.subtitle')}
            </span>
            <ul>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.support.items.item1',
                )}
              </li>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.support.items.item2',
                )}
              </li>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.support.items.item3',
                )}
              </li>
              <li>
                {t(
                  'solutionsDigitalSupplyChain_page.performance.cards.support.items.item4',
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>

      <section className="main-cases-container">
        <h2 className="title">{t('solutionsDigitalSupplyChain_page.cases.title')}</h2>
        <Pagination data={casesDigitalSupplyChain} itemsPerPage={4}>
          {(currentItems) => (
            <div className="main-cases-content">
              {currentItems.map((caseItem) => (
                <article key={caseItem.id} className="case-card">
                  <span className="case-icon">{caseItem.icon}</span>
                  <h3>{caseItem.title}</h3>
                  <p>{caseItem.description}</p>
                  <a
                    href="#!"
                    onClick={(e) => {
                      e.preventDefault()
                      handleRelatedCaseCtaClick(caseItem)
                    }}
                  >
                    {t('solutionsDigitalSupplyChain_page.cases.cta')} →
                  </a>
                </article>
              ))}
            </div>
          )}
        </Pagination>
      </section>
    </section>
  )
}

export default SolutionsDigitalSupplyChain
